var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "91px",
    viewBox: "0 0 97 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loading") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading",
    transform: "translate(46.453398, 49.194133) scale(1, -1) rotate(73.000000) translate(-46.453398, -49.194133) translate(4.953398, 0.694133)",
    fill: "#BDBDBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5889819,-0.00046772224 C61.5488468,0.0233510116 73.3155726,5.13031863 82.0029395,13.4324167 L70.9351613,24.500186 C64.8992581,18.8485716 57.088998,15.7179774 48.7913911,15.6464008 C30.721621,15.4903405 15.4900786,30.1136653 15.6463347,48.7832166 C15.7945726,66.4937204 30.1529194,81.3548514 48.5,81.3548514 C56.5429819,81.3548514 64.1445746,78.4843578 70.1351069,73.227979 C71.0626694,72.4142357 72.463498,72.4637135 73.3361069,73.3361261 L81.0925867,81.0925996 C82.045377,82.0453892 81.998246,83.5987569 80.9983246,84.5018731 C72.398375,92.2698849 61.0016573,97 48.5,97 C21.7143105,97 0,75.2859027 0,48.5004306 C0,21.7454664 21.833996,-0.0478344144 48.5889819,-0.00046772224 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.f8d56fd58925a1aaab4f80f1d8865c03.svg";
export { ForwardRef as ReactComponent };